export enum TypeObjetSyncError {
    INSPECTION = 0,
    AUDIT = 1
}
